<div class="element-form-container dsforms-element-header-container no-bottom-pad">
    <div class="header-text" [innerHTML]="headerHtml" qa="form-header"></div>
</div>
